import React, { useEffect, useState } from 'react';
import AddSorteo from './AddSorteo.jsx';
import { useSelector, useDispatch } from 'react-redux';
import { selectStateSorteos, setSorteos } from '../../slice/global.js';
import { CallApiPost, CallApiGet } from '../../apicalls/calls.js';
import { Outlet, useOutlet } from 'react-router-dom';
import FiltroSorteo from './FiltroSorteo.jsx';
import Paginate from '../Parts/Paginate.jsx';


export default function sorteo() {
    var hasSubRoute = useOutlet();
    //console.log("pruebaHijo", Hijo != null ? 'Tine Oulet' : "vacio");
    const AllSorteos = useSelector(selectStateSorteos);
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const dispatch = useDispatch();
    const [singleS, setSingleS] = useState({
        id: '',
        nombre: '',
        fecha_fin: '',
        fecha_inicio: '',
        hora_fin: '',
        multiple: '',
    });

    //Paginacion
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 5;


    useEffect(() => {
        hasSubRoute == null ? fetchData() : console.log("");
    }, []);

    useEffect(() => {
        return (() => {
            //Test de la tabla
            $("#backdrop").hide();

        })
    }, [AllSorteos]);

    async function fetchData() {
        $("#backdrop").show();
        const Call = await CallApiGet('getSorteos', null, UsuarioS.access_token);
        //await console.log("Llamada de get", Call);
        dispatch(setSorteos(Call.success.sorteos));

        //Paginacion
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(Call.success.sorteos.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(Call.success.sorteos.length / itemsPerPage));
    }

    async function endSorteo(tipo, id) {
        $("#backdrop").show();
        let params = { tipo: tipo, id: id };
        const resp = await CallApiPost('accionesSorteos', params, UsuarioS.access_token);
        if (resp.status != 200) {
            alert("error al momento de guardar");
        } else {
            //actions.resetForm();
            fetchData();
        }
    }

    const Save = async (values, actions) => {
        window.Swal.fire({
            title: '¿Está seguro de agregar un nuevo sorteo?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                $("#backdrop").show();
                $('#addSorteo').modal('hide');
                const res = await CallApiPost('saveSorteos', values, UsuarioS.access_token);
                //console.log("estatus", res.status);
                if (res.status != 200) {
                    window.Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: res.error.message,
                    });
                } else {
                    //$('#addSorteo').modal('hide');
                    await fetchData();
                    actions.resetForm();
        
                }
            }
        })
        
    }

    const Filter = async (values, actions) => {
        $("#backdrop").show();
        //var params = { id_usuario: UsuarioS.user.id }
        var params = { ...values };
        params.id_usuario = UsuarioS.user.id;
        //console.log(params);
        const Call = await CallApiGet('getSorteos', params, UsuarioS.access_token);
        dispatch(setSorteos(Call.success.sorteos));
        //Paginacion
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(Call.success.sorteos.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(Call.success.sorteos.length / itemsPerPage));
    }

    //Paginacion

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(AllSorteos.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(AllSorteos.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % AllSorteos.length;
        setItemOffset(newOffset);
    };

    const EditSorteo = (item) => {
        var Sorteo = {
            id: item.id,
            nombre: item.nombre,
            fecha_fin: moment(item.fecha_fin).format('YYYY-MM-DD'),
            fecha_inicio: moment(item.fecha_inicio).format('YYYY-MM-DD'),
            hora_fin: item.hora_fin,
            multiple: item.multiple == 1 ? true : false,
        }
        setSingleS(Sorteo);
        $('#addSorteo').modal('show');
    }

    const openM = () => {
        var Sorteo = {
            id: '',
            nombre: '',
            fecha_fin: '',
            fecha_inicio: '',
            hora_fin: '',
            multiple: '',
        }
        setSingleS(Sorteo);
        $('#addSorteo').modal('show');
    }

    return (
        hasSubRoute == null ?
            <div className='container-fluid'>
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="h3 mb-0 text-gray-800">Sorteos</h1>
                    <a onClick={() => openM()}
                        className="d-sm-inline-block btn btn-sm shadow-sm text-white" style={{ background: "#E6453B" }}>
                        <i className="fas fa-plus fa-sm text-white-50"></i> Nuevo Sorteo
                    </a>
                </div>
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold " style={{ color: "#E6453B" }}>Registros</h6>
                    </div>
                    <div className='card-body'>
                        <FiltroSorteo Filter={Filter} />
                        <div className='table-responsive'>
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Fecha Incio</th>
                                        <th>Fecha Fin</th>
                                        <th>Estatus</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length == 0 && (
                                        <tr className='text-center'>
                                            <td colSpan={5}>No hay registros en la tabla</td>
                                        </tr>
                                    )}
                                    {currentItems && currentItems.map((item, key) => (
                                        <tr key={key}>
                                            <td>{item.nombre}</td>
                                            <td>{window.moment(item.fecha_inicio).locale('es-mx').format('L')}</td>
                                            <td>{window.moment(item.fecha_fin).locale('es-mx').format('L')}</td>
                                            <td>{item.estatus}</td>
                                            <td className="text-center">
                                                {item.estatus == "ACTIVO" ?
                                                    <>
                                                        <a className="btn btn-danger btn-circle btn-sm" onClick={() => endSorteo(1, item.id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Finalizar captura" ><i className="fa fa-times"></i></a>
                                                        <a className="btn btn-success btn-circle btn-sm" onClick={() => EditSorteo(item)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar sorteo" ><i className="fa fa-file-signature"></i></a>
                                                        <a className="btn btn-info btn-circle btn-sm" href={`${process.env.BASEURL}/Sorteos/Info/${item.id}`} data-bs-toggle="tooltip" data-bs-placement="top" title="Ver sorteo" ><i className="fas fa-eye"></i></a>
                                                    </> :
                                                    <a className="btn btn-info btn-circle btn-sm" href={`${process.env.BASEURL}/Sorteos/Info/${item.id}`} data-bs-toggle="tooltip" data-bs-placement="top" title="Ver sorteo" ><i className="fas fa-eye"></i></a>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='float-md-right'>
                            <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
                        </div>
                    </div>
                </div>
                <AddSorteo Save={Save} Singles={singleS} />
            </div> :
            <Outlet />
    )
}
